/**
 * Same rule as the database's listing slug: lower-case, runs of anything
 * other than a–z / 0–9 become one hyphen, no leading or trailing hyphen.
 */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
